import { CSSProperties } from 'react';

// Subtle right-edge shadow so the pinned column reads as raised above the
// content scrolling underneath it.
const PINNED_COLUMN_SHADOW = '2px 0 5px -2px rgba(14, 23, 28, 0.15)';

// Width (px) of the leading fixed tracks (drag handle, row-select checkbox).
// Kept in sync with the '40px' tracks emitted by generateGridTemplateColumns.
export const LEADING_TRACK_WIDTH = 40;

export interface PinnedColumnInfo {
	isPinned: boolean;
	left: number;
	isLast: boolean;
}

export const getPinnedColumnInfo = (
	pinnedColumns: Record<string, number> | undefined,
	lastPinnedColumnId: string | undefined,
	columnId: string
): PinnedColumnInfo => {
	const left = pinnedColumns?.[columnId];

	return {
		isPinned: left !== undefined,
		left: left ?? 0,
		isLast: columnId === lastPinnedColumnId,
	};
};

interface PinnedColumnStyleOptions {
	backgroundColor?: string;
	left?: number;
	withShadow?: boolean;
}

export const getPinnedColumnStyle = (
	isPinned: boolean,
	zIndex: number,
	{ backgroundColor, left = 0, withShadow = true }: PinnedColumnStyleOptions = {}
): CSSProperties =>
	isPinned
		? {
				position: 'sticky',
				left,
				zIndex,
				...(withShadow ? { boxShadow: PINNED_COLUMN_SHADOW } : {}),
				...(backgroundColor
					? {
							backgroundColor: 'white',
							backgroundImage: `linear-gradient(${backgroundColor}, ${backgroundColor})`,
						}
					: {}),
			}
		: {};
